import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "com_bg1" }
const _hoisted_2 = { id: "wrapper1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: "/WITH_AG_PORTAL/images/with-kaunet_logo2.png",
  alt: "ウィズカウネット エージェントポータル",
  class: "with-kaunet_logo2"
}, null, -1)
const _hoisted_4 = { class: "com_form_contet1" }
const _hoisted_5 = { class: "inner1" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "title1" }, "ワンタイムパスワード", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "com_center1 com_mgb30" }, " メールに記載のコードを入力してください。 ", -1)
const _hoisted_8 = { class: "form1 tp1 com_mgb40" }
const _hoisted_9 = { class: "group1" }
const _hoisted_10 = {
  key: 0,
  class: "error-message",
  style: {"margin-left":"140px"}
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "com_copyright1" }, "© 2025 Kaunet", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlphanumericInput = _resolveComponent("AlphanumericInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_AlphanumericInput, {
                id: "otp",
                modelValue: _ctx.otp,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.otp) = $event)),
                type: "text",
                maxlength: "6"
              }, null, 8, ["modelValue"])
            ]),
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "submit",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submitOtp && _ctx.submitOtp(...args))),
              disabled: _ctx.isProcessing
            }, " ログイン ", 8, _hoisted_11)
          ])
        ])
      ]),
      _hoisted_12
    ])
  ]))
}